import { useMemo } from 'react'
import { ADMIN_ROLES, SERVICE_LEVELS } from 'src/Configuration/user'
import { useUser } from 'src/Hooks/useUser'
import { UserLevel } from 'src/State/User/UserModel'

interface UseUserRoles {
  /**
   * Is authenticated user is of access level "User"
   */
  isUser: boolean
  /**
   * Is authenticated user is of access level "Installer"
   */
  isInstaller: boolean
  /**
   * Is authenticated user is of access level "Admin"
   */
  isAdmin: boolean
  /**
   * Is authenticated user is of access level "Partner"
   */
  isPartner: boolean
  /**
   * Is authenticated user is of access level "Service" in any kind
   */
  isServiceUser: boolean
  /**
   * The actual current access role
   */
  currentRole: UserLevel | undefined
}

/**
 * Returns helpers to determine the access role of the currently authenticated user
 */
const useUserRoles = (): UseUserRoles => {
  const { userData } = useUser()
  const isUser = useMemo(() => userData?.level === 'USER', [userData?.level])
  const isInstaller = useMemo(() => userData?.level === 'INSTALLER', [userData?.level])
  const isAdmin = useMemo(() => ADMIN_ROLES.includes(userData?.level as UserLevel), [userData?.level])
  const isPartner = useMemo(() => userData?.level === 'PARTNER', [userData?.level])
  const isServiceUser = useMemo(() => (userData?.level ? SERVICE_LEVELS.includes(userData?.level) : false), [userData?.level])

  return { isUser, isInstaller, isPartner, isServiceUser, isAdmin, currentRole: userData?.level }
}

export default useUserRoles
